export default "__VITE_ASSET__UjG1OxlJ__"